var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLink1 = function SvgLink1(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-24": 18,
    viewBox: "0 0 18 18",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.463 6.867a.7.7 0 0 1 .99.99l-3.108 3.108c-1.102 1.102-1.382 3.01-.066 4.461l.132.14.14.131c1.45 1.316 3.358 1.036 4.46-.066l3.108-3.107a.701.701 0 0 1 .99.99L8.002 16.62c-1.625 1.625-4.511 2.005-6.581-.065s-1.69-4.957-.066-6.581zm6.869-1.212a.7.7 0 0 1 .99.99l-5.657 5.657a.7.7 0 0 1-.99-.99zm-1.358-4.3C11.6-.27 14.485-.65 16.555 1.42s1.691 4.957.067 6.581l-3.108 3.108a.7.7 0 0 1-.99-.99l3.108-3.108C16.734 5.91 17.013 4 15.697 2.55l-.132-.139-.138-.132c-1.45-1.316-3.36-1.036-4.462.066L7.857 5.452a.7.7 0 0 1-.99-.99z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLink1);
export default ForwardRef;